import Store from 'modules/state/Store'
import * as Actions from 'modules/state/help/Actions'

export const setHelp = (helpKey) => {
    Store.dispatch(Actions.setHelp(helpKey));
}

export const clearHelp = (helpKey) => {
    Store.dispatch(Actions.clearHelp(helpKey));
}

// User Setup
export const userSetupHelpKey = "Admin/UserSetup";
export const userSetupAuditHelpKey = "Admin/UserSetup/Audit";
export const userSetupInfoHelpKey = "Admin/UserSetup/Info";

// Sponsor Setup
export const sponsorSetupHelpKey = "Admin/SponsorSetup";
export const sponsorSetupAuditHelpKey = "Admin/SponsorSetup/Audit";
export const sponsorSetupInfoHelpKey = "Admin/SponsorSetup/Info";
export const sponsorSetupUsersHelpKey = "Admin/SponsorSetup/Users";
export const sponsorSetupHistoryHelpKey = "Admin/SponsorSetup/SponsorHistory";
export const sponsorSetupNotificationsHelpKey = "Admin/SponsorSetup/Notifications";

// DD214 Setup
export const dd214SetupHelpKey = "Admin/DD214Setup";

// Account Setup
export const accountSetupHelpKey = "Admin/AccountSetup";
export const accountSetupAuditHelpKey = "Admin/AccountSetup/Audit";
export const accountSetupInfoHelpKey = "Admin/AccountSetup/Info";

// App Config Setup
export const appConfigSetupHelpKey = "Admin/AppConfig/Setup";
export const appConfigSettingsHelpKey = "Admin/AppConfig/Settings";
export const appConfigAuditHelpKey = "Admin/AppConfig/Audit";

// Role Setup
export const roleSetupHelpKey = "Admin/RoleSetup";
export const roleSetupAuditHelpKey = "Admin/RoleSetup/Audit";
export const roleSetupInfoHelpKey = "Admin/RoleSetup/Info";
export const roleSetupUsersHelpKey = "Admin/RoleSetup/Users";

// Tooltip Manager Setup
export const tooltipManagerSetupHelpKey = "Admin/TooltipManagerSetup";
export const tooltipManagerSetupAuditHelpKey = "Admin/TooltipManagerSetup/Audit";
export const tooltipManagerSetupInfoHelpKey = "Admin/TooltipManagerSetup/Info";

// Emailing Log
export const emailingLogHelpKey = "Admin/EmailingLog";
export const emailingLogInfoHelpKey = "Admin/EmailingLog/EmailInfo"

// Email Templates Setup
export const emailTemplateSetupHelpKey = "Admin/EmailTemplates"
export const emailTemplateSetupInfoHelpKey = "Admin/EmailTemplates/TemplateInfo"

// PayPal Invoices Setup
export const paypalInvoiceSetupHelpKey = "Admin/PaypalInvoiceSetup";
export const paypalInvoiceSetupInfoHelpKey = "Admin/EmailTemplates/PaypalInvoiceInfo"

// Report Management Setup
export const reportManagementHelpKey = "Admin/ReportManagement";

// News Setup
export const newsSetupHelpKey = "Admin/NewsSetup";
export const newsSetupAuditHelpKey = "Admin/NewsSetup/Audit";
export const newsSetupInfoHelpKey = "Admin/NewsSetup/Info";

// Terms & Conditions Setup
export const termsAndConditionsSetupHelpKey = "Admin/TermsAndConditionsSetup";
export const termsAndConditionsSetupAuditHelpKey = "Admin/TermsAndConditionsSetup/Audit";
export const termsAndConditionsSetupInfoHelpKey = "Admin/TermsAndConditionsSetup/Info";

// Notification Setup
export const notificationSetupHelpKey = "Admin/NotificationSetup";
export const notificationSetupAuditHelpKey = "Admin/NotificationSetup/Audit";
export const notificationSetupInfoHelpKey = "Admin/NotificationSetup/Info";

// Help Topics Setup
export const helpSetupHelpKey = "Admin/HelpTopicsSetup";
export const helpSetupAuditHelpKey = "Admin/HelpTopicsSetup/Audit";
export const helpSetupInfoHelpKey = "Admin/HelpTopicsSetup/Info";

// Audit Review
export const auditReviewHelpKey = "Admin/AuditReview";

// My Profile
export const userProfileInfoHelpKey = "Admin/MyProfile/Info";
export const userProfileSecurityHelpKey = "Admin/MyProfile/Security";

// Demo
export const demoHelpKey = "Demo/PrimeroDemo";

// Data Import
export const dataImportHelpKey = "Data/DataImport/Users";

// Report Manager
export const reportManagerSchedulesHelpKey = "Reports/ReportManager/MySchedules";
export const reportManagerExecutingHelpKey = "Reports/ReportManager/CurrentlyExecuting";
export const reportManagerHistoryHelpKey = "Reports/ReportManager/History";

// Users Report
export const userReportSummaryHelpKey = "Reports/UserReports/UserSummaryReport";

// Dashboard
export const dashboardSupportHelpKey = "Dashboard/Support";
export const dashboardLogsHelpKey = "Dashboard/Logs";

// Discount Code Setup
export const discountCodeSetupHelpKey = "Admin/DiscountCodeSetup";
export const discountCodeSetupInfoHelpKey = "Admin/DiscountCodeSetup/Info";
export const discountCodeSetupAuditHelpKey = "Admin/DiscountCodeSetup/Audit";



// WEBPACK FOOTER //
// ./src/modules/app/Help.js